import AuthGateway from './AuthGateway'
import UserModel from './UserModel'
import * as Navigator from '../../modules/Navigator'
import { getFromStorage, saveToStorage, destroyStorage } from '../storage'

export default class AuthService {
  constructor (authGateway) {
    this.AuthGateway = authGateway || new AuthGateway()

    this.login = this.login.bind(this)
    this.syncAccounts = this.syncAccounts.bind(this)
    this.updateAccount = this.updateAccount.bind(this)
    this.userInfo = this.userInfo.bind(this)
    this.getAccounts = this.getAccounts.bind(this)
    this.getRoles = this.getRoles.bind(this)
    this.setPassword = this.setPassword.bind(this)
    this.setEmail = this.setEmail.bind(this)
    this.assignRole = this.assignRole.bind(this)
    this.unassignRole = this.unassignRole.bind(this)
    this.deleteAccount = this.deleteAccount.bind(this)
    this.createAccount = this.createAccount.bind(this)
  }

  login (query = {}) {
    return this.AuthGateway
      .login(query)
      .then(response => {
        saveToStorage(response)
        return new UserModel(response)
      })
  }

  userInfo () {
    return this.AuthGateway
    .userInfo()
    .then(response => response)
  }

  syncAccounts () {
    return this.AuthGateway
    .syncAccounts()
    .then(response => response)
  }

  getAccounts () {
    return this.AuthGateway
    .getAccounts()
    .then(response => response.map(item => ({
      ...item,
      id: item.email,
      value: item.userName
    })))
  }

  getRoles () {
    return this.AuthGateway
    .getRoles()
    .then(response => response.map(item => ({
      id: item,
      name: item
    })))
  }

  setPassword (query) {
    return this.AuthGateway
    .setPassword(query)
    .then(response => response)
  }

  updateAccount (query) {
    return this.AuthGateway
    .updateAccount(query)
    .then(response => response)
  }

  setEmail (query) {
    return this.AuthGateway
    .setEmail(query)
    .then(response => response)
  }

  assignRole (query) {
    return this.AuthGateway
    .assignRole(query)
    .then(response => response)
  }

  createAccount (query) {
    return this.AuthGateway
    .createAccount(query)
    .then(response => response)
  }

  unassignRole (query) {
    return this.AuthGateway
    .unassignRole(query)
    .then(response => response)
  }

  deleteAccount (query) {
    return this.AuthGateway
    .deleteAccount(query)
    .then(response => response)
  }

  getUser () {
    return getFromStorage()
  }

  logOut () {
    destroyStorage()
    Navigator.goToPage(Navigator.LOGIN_PAGE)
  }
}



// WEBPACK FOOTER //
// ./src/api/auth/AuthService.js